module.exports = __webpack_public_path__ + "img/cn.3e6d7311.svg";